import { Box, Typography, useTheme } from "@mui/material";
import { FC } from "react";
import { RemovableChip } from "../../../../components";
import { useLocalization } from "../../../../hooks/useLocalization";

interface DateRangeActionsProps {
  startDate: Date | null;
  endDate: Date | null;
  onRemoveStartDate: () => void;
  onRemoveEndDate: () => void;
  formatDate: (date: Date) => string;
}

export const DateRangeActions: FC<DateRangeActionsProps> = ({
  startDate,
  endDate,
  onRemoveStartDate,
  onRemoveEndDate,
  formatDate,
}) => {
  const theme = useTheme();
  const { t } = useLocalization();

  const hasSelectedRange = Boolean(startDate) || Boolean(endDate);

  return (
    <Box sx={{ px: 2, pb: 2 }}>
      <Typography
        sx={{
          fontWeight: 400,
          fontSize: 12,
          color: theme.colors.text[1],
          mb: 1,
        }}
      >
        {t("pages.dataAnalytics.internalUsage.dateRangeActions.label")}
      </Typography>
      {hasSelectedRange ? (
        <Box
          sx={{
            display: "flex",
            gap: 1,
            flexWrap: "wrap",
            height: "50px",
          }}
        >
          {startDate && (
            <RemovableChip
              fontWeight={500}
              label={`${t("pages.dataAnalytics.internalUsage.dateRangeActions.from")}: ${formatDate(startDate)}`}
              onDelete={onRemoveStartDate}
            />
          )}
          {endDate && (
            <RemovableChip
              fontWeight={500}
              label={`${t("pages.dataAnalytics.internalUsage.dateRangeActions.to")}: ${formatDate(endDate)}`}
              onDelete={onRemoveEndDate}
            />
          )}
        </Box>
      ) : (
        <Box
          sx={{
            height: "50px",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: 12,
              color: theme.colors.text[1],
              mt: 1,
            }}
          >
            {t(
              "pages.dataAnalytics.internalUsage.dateRangeActions.noDateSelected",
            )}
          </Typography>
        </Box>
      )}
    </Box>
  );
};
